var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CoolLightBox',{attrs:{"items":_vm.images,"index":_vm.index},on:{"close":_vm.$lightBox.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }